import {
  CButton,
  CCardHeader,
  CCol,
  CInput,
  CLabel,
  CRow,
  CSpinner,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Auth from "src/auth";
import { formatDate } from "src/shared/Format/dateFormat";
import { apiCall, downloadUrl } from "src/_apiConfig/apiCall";
const OfflinePaymentListView = () => {
  let history = useHistory();

  let { id } = useParams();
  const [viewListDetails, setviewListDetails] = useState();

  const [showList, setshowList] = useState();
  const { authenticated } = Auth();

  const acceptHandler = async (id) => {
    const getData = viewListDetails;
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      `OfflinePayment/Update`,
      "POST",
      header,
      JSON.stringify({
        id: Number(id),
        type: Number(getData.type),
        amount: Number(getData.amount),
        status: 1,
        objectId: Number(getData.objectId),
        userId: Number(getData.paidByUser.userid),
        approvedBy: Number(authenticated.userId),
        filePath: getData.filePath,
      })
    );
    await response.json();
    if (response.status === 200) {
      history.push("/other/offlinepaymentslist");
    }
  };

  const rejectHandler = async (id) => {
    const getData = viewListDetails;
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      `OfflinePayment/Update`,
      "POST",
      header,
      JSON.stringify({
        id: Number(id),
        type: Number(getData.type),
        amount: Number(getData.amount),
        status: 2,
        objectId: Number(getData.objectId),
        userId: Number(getData.paidByUser.userid),
        approvedBy: Number(authenticated.userId),
        filePath: getData.filePath,
      })
    );
    await response.json();
    if (response.status === 200) {
      history.push("/other/offlinepaymentslist");
    }
  };

  const getLotDetails = async () => {
    if (authenticated) {
      const header = new Headers();
      // header.append("", "");
      const responseListView = await apiCall(
        `OfflinePayment/Get?$filter=id eq ${id}`,
        "GET",
        header,
        null
      );
      const jsonobjListView = await responseListView.json();
      if (responseListView.status === 200 && jsonobjListView.length > 0) {
        setviewListDetails(jsonobjListView[0]);
        setshowList(true);
      }
    } else {
      setshowList(false);
    }
  };

  useEffect(() => {
    getLotDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, authenticated]);

  return (
    <>
      {!showList ? (
        <CSpinner
          className="spinner-grow col-6 offset-6 mt-6"
          color="success"
        />
      ) : (
        authenticated && (
          <CCardHeader>
            <CRow className="pt-3" xl={12}>
              <CCol xl={10}>
                <h3>Offline Payment Details</h3>
              </CCol>
            </CRow>
            <div className="pl-5 pr-5">
              <hr />

              <CRow>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    Email ID. :
                  </CLabel>
                  <CInput
                    value={
                      viewListDetails.paidByUser.emailId === null
                        ? " "
                        : viewListDetails.paidByUser.emailId
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">Amount :</CLabel>
                  <CInput
                    value={
                      viewListDetails.amount === null
                        ? " "
                        : viewListDetails.amount
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    Request Date :
                  </CLabel>
                  <CInput
                    value={
                      viewListDetails.insertDateTime === null
                        ? " "
                        : formatDate(viewListDetails.insertDateTime)
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">Type :</CLabel>
                  <CInput
                    value={
                      viewListDetails.type === null
                        ? " "
                        : viewListDetails.type === 1
                        ? "Transfer"
                        : "Lot Payment"
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={1} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    View Image :
                  </CLabel>{" "}
                  <a
                    target="_blank"
                    // href={`http://192.168.1.11/CG_API1/${viewListDetails.filePath}`}
                    href={`${downloadUrl}/${viewListDetails.filePath}`}
                    rel="noreferrer"
                    // href={`http://202.131.108.246:82/${viewListDetails.filePath}`}
                  >
                    <CButton variant="outline" color="info">
                      View
                    </CButton>
                  </a>
                </CCol>
                <CCol xl={2} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">Status :</CLabel>
                  <h5>
                    {viewListDetails.status === null ? (
                      " "
                    ) : viewListDetails.status === 0 ? (
                      <span class="badge bg-warning text-dark">Pending</span>
                    ) : viewListDetails.status === 1 ? (
                      <span class="badge bg-success text-light">Accepted</span>
                    ) : (
                      <span class="badge bg-danger text-light">Rejected</span>
                    )}
                  </h5>
                </CCol>
              </CRow>
            </div>

            <div className="pl-5 pr-5">
              {viewListDetails && viewListDetails.status === 0 ? (
                <>
                  <CButton
                    key="accept"
                    color="info"
                    className="mt-5 ml-2"
                    // to={props.seccpath + item[props.id]}
                    onClick={() => {
                      acceptHandler(viewListDetails.id);
                    }}
                  >
                    Accept
                  </CButton>
                  <CButton
                    key="reject"
                    color="danger"
                    className="mt-5 ml-2 mr-2"
                    // to={props.seccpath + item[props.id]}
                    onClick={() => rejectHandler(viewListDetails.id)}
                  >
                    Reject
                  </CButton>
                </>
              ) : (
                ""
              )}

              <CButton
                className="mt-5"
                color="dark"
                onClick={() => history.goBack()}
              >
                Go Back
              </CButton>
            </div>
          </CCardHeader>
        )
      )}
    </>
  );
};
export default OfflinePaymentListView;
